export enum SquareEnum {
  Unknown,
  Hit,
  Miss,
  Empty,
  Ship,
}
